import { Controller } from "stimulus";
import { getCSRFToken, setUpdatedCsrfMetaContent } from "../../util";

export default class extends Controller {
  static targets = ["todayBox", "day7", "balance", "collectButton", "pointTransactionContainer", "showMore",
    "loadMoreButton"];

  static values = {
    unclaimed: String,
    claimed: String,
    finalClaimed: String,
    claimCandy: String,
  }

  connect() {
    import("@lottiefiles/lottie-player")

    if (this.collectButtonTarget.disabled) {
      this._updateButtonStatus()
    }

    this.lottiePlayer = document.getElementById('lottiePlayer');
  }

  clearQueryParams() {
    window.history.replaceState(null, '', window.location.pathname);
  }

  loadFinalClaimed() {
    this.lottiePlayer.load(this.finalClaimedValue)
  }

  loadClaimed() {
    this.lottiePlayer.load(this.claimedValue)
  }

  collectCandy() {
    this.collectButtonTarget.disabled = true
    this._collectPoints()
  }

  _updateClaimedTodayBox() {
    this.todayBoxTarget.classList.remove("tw-bg-transparent")
    this.todayBoxTarget.classList.add("tw-bg-primary-500", "dark:tw-bg-primary-400")

    const candyAmountTextElements = this.todayBoxTarget.querySelectorAll(".candy-amount");

    candyAmountTextElements.forEach((amountText) => {
      amountText.innerHTML = "<i data-view-component='true' class='fa-circle-check tw-text-white dark:tw-text-primary-900 tw-text-3xl fas'></i>"
    });

    const dayText = this.todayBoxTarget.querySelector(".day-text");
    dayText.classList.remove("tw-text-gray-500", "dark:tw-text-moon-200")
    dayText.classList.add("tw-text-white", "dark:tw-text-primary-900")
  }

  async _collectPoints() {
    await setUpdatedCsrfMetaContent();
    this.claimCandyPath = this.claimCandyValue

    fetch(this.claimCandyPath, {
      method: "POST",
      headers: {
        "X-CSRF-Token": getCSRFToken(),
      },
      credentials: "same-origin",
    }).then(
      response => {
        response.json()
        if (response.ok) {
          Toaster.toast(I18n.t("candy.candy_collected", { candyAmount: parseInt(this.todayBoxTarget.dataset.points) }))

          this._updateCandyJar()
          this._updateCandyBalance()
          this._updateButtonStatus()
          this._updateClaimedTodayBox()
        } else {
          this.collectButtonTarget.disabled = false
          Toaster.toast("Something went wrong.", { icon: { classes: "fas fa-times tw-text-danger-500" } })
        }

      }
    );
  }

  _updateCandyJar() {
    if (this.todayBoxTarget.getAttribute("data-day") == "day7") {
      this.loadFinalClaimed()
    } else {
      this.loadClaimed()
    }
  }

  _updateCandyBalance() {
    let todayReward = parseInt(this.todayBoxTarget.dataset.points);
    let candyBalance = parseInt(this.balanceTarget.innerHTML);
    let updatedCandyBalance = candyBalance + todayReward;

    import("countup.js").then(({CountUp}) => {
      var countUp = new CountUp(this.balanceTarget, updatedCandyBalance, {
        duration: 1,
      });
      countUp.start();
    })
  }

  _updateButtonStatus() {
    this.collectButtonTarget.disabled = true
    this.startCountdown()
    setInterval(this.startCountdown, 1000);
  }

  startCountdown() {
    var tomorrow = new Date();
    tomorrow.setDate(new Date().getDate() + 1);
    var nextBeginningOfTheDayTimeStamp = new Date(tomorrow).setUTCHours(0, 0, 0, 0);

    let dateEnd = new Date(nextBeginningOfTheDayTimeStamp);
    dateEnd = dateEnd.getTime();

    if (isNaN(dateEnd)) {
      return;
    }

    var hours, minutes, seconds;
    var dateStart = new Date();
    var timeRemaining = parseInt((dateEnd - dateStart.getTime()) / 1000)

    if (timeRemaining >= 0) {
      hours = parseInt(timeRemaining / 3600);
      timeRemaining = (timeRemaining % 3600);
      minutes = parseInt(timeRemaining / 60);
      timeRemaining = (timeRemaining % 60);
      seconds = parseInt(timeRemaining);

      const countdownTime = `${("0" + hours).slice(-2)}:${("0" + minutes).slice(-2)}:${("0" + seconds).slice(-2)}`
      const nextCollectionCandyAmount = document.getElementById("todayBox").dataset.nextDayPoints
      document.getElementById("collectButton").firstElementChild.innerHTML = I18n.t("candy.to_collect_x_candy", { countdown: countdownTime, candyAmount: nextCollectionCandyAmount })
    } else {
      return;
    }
  }

  async showMorePointsTransactions(e) {
    const response = await fetch(e.currentTarget.dataset.url);
    if (response.status === 200) {
      const html = await response.text();

      this.pointTransactionContainerTarget.innerHTML = html;
    }
  }
}
